import React from 'react';
import OrangeCheckIcon from '@repo/ui/src/components/Icons/OrangeCheck';
import ExcludedIcon from '@repo/ui/src/components/Icons/ExcludedIcon';

interface Props {
  salesforceValue: string | number | boolean | undefined;
}

const isTruthy = (value: string | number | boolean | undefined) =>
  value === true || (typeof value === 'string' && value.toLowerCase() === 'true');

const isBoolean = (value: string | number | boolean | undefined) =>
  typeof value === 'boolean' ||
  (typeof value === 'string' &&
    (value.toLowerCase() === 'true' || value.toLowerCase() === 'false'));

const Value = ({ salesforceValue }: Props) =>
  isBoolean(salesforceValue) ? (
    isTruthy(salesforceValue) ? (
      <OrangeCheckIcon />
    ) : (
      <ExcludedIcon />
    )
  ) : (
    <p className="tra-text-web-body-l">{salesforceValue ?? '—'}</p>
  );

export default Value;
